// Outils partagés pour les appels Cegid Y2 depuis les composants.
// La file d'attente est commune à TOUS les composants : même avec 100 CodeArticle à l'écran,
// il n'y a jamais plus de LIMITE_APPELS requêtes Cegid en même temps.
import axios from 'axios'
import store from '@/store'

export const API_Y2 = '/cegid-api/Y2/98661025_001_PROD/api'
export const LIMITE_PRIX = 50   // selling-prices : codes-barres par appel
export const LIMITE_STOCK = 20  // available-quantities / inventory-quantities : 21 max par appel
const LIMITE_APPELS = 10

let actifs = 0
const attente = []

function suivant() {
  while (actifs < LIMITE_APPELS && attente.length) {
    const { tache, resolve, reject } = attente.shift()
    actifs++
    Promise.resolve()
      .then(tache)
      .then(resolve, reject)
      .finally(() => { actifs--; suivant() })
  }
}

/** Exécute tache() quand une place se libère dans la file commune. */
export const limiter = tache => new Promise((resolve, reject) => { attente.push({ tache, resolve, reject }); suivant() })

/** GET Cegid Y2 passant par la file commune. barcodes: ['A','B'] -> barcodes=A&barcodes=B */
export const appelY2 = (chemin, params) =>
  limiter(() => axios.get(`${API_Y2}${chemin}`, {
    params,
    paramsSerializer: { indexes: null },
    headers: { Authorization: `Bearer ${store.state.token_y2}` },
  }))

export function decouper(liste, taille) {
  const lots = []
  for (let i = 0; i < liste.length; i += taille) lots.push(liste.slice(i, i + taille))
  return lots
}

/** DEPO / DWEB n'ont pas de tarif propre : on utilise WEDI. */
export const etabPrix = etab =>
  !etab || store.state.itemsEtablissemnt?.etabDEPO?.etabliss?.includes(etab) ? 'WEDI' : etab

/** Date Cegid (UTC) -> date de Paris "15/10/2026", sans décalage d'un jour. */
export const dateFR = iso => (iso ? new Date(iso).toLocaleDateString('fr-FR', { timeZone: 'Europe/Paris' }) : '')
